import React from 'react'
import { Link } from 'react-router-dom'

export default class extends React.Component {
    render() {
		return (
			<h1 className="entry-title">No statement available</h1>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Statement/components/NoStatementPart.jsx